import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = { class: "DialogSectionTitle F1_5em" }
const _hoisted_5 = {
  class: "DialogSection",
  id: "TableToPrint"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_7 = { class: "DialogSectionTitle F1_5em" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRow F-C2" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_10 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving || _ctx.Loading.length)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.Translate('Target Quantity')) + ": " + _toDisplayString(_ctx.DialogData?.Quantity), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CookiesTable, {
              class: "Shadow1",
              TableSettings: _ctx.TableSettings,
              CookiesData: _ctx.DecodedAvailable
            }, null, 8, ["TableSettings", "CookiesData"])
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.Translate('Selected Quantity')) + ": " + _toDisplayString(_ctx.Total), 1),
          _hoisted_8
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access('Inventory_AvailableItems_Override'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Close')), 1),
            _createElementVNode("button", {
              class: _normalizeClass([_ctx.Total !== _ctx.DialogData?.Quantity ? 'Disabled' : '', "F-Bold CookiesButton DialogFooterButton"]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main)
            }, _toDisplayString(_ctx.Translate('Save')), 7)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}